import { render, staticRenderFns } from "./textareaModule.vue?vue&type=template&id=6744c8f2&lang=html"
import script from "./textareaModule.vue?vue&type=script&lang=js"
export * from "./textareaModule.vue?vue&type=script&lang=js"
import style0 from "./textareaModule.vue?vue&type=style&index=0&id=6744c8f2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/erp-flexible-web21_zo1Z/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6744c8f2')) {
      api.createRecord('6744c8f2', component.options)
    } else {
      api.reload('6744c8f2', component.options)
    }
    module.hot.accept("./textareaModule.vue?vue&type=template&id=6744c8f2&lang=html", function () {
      api.rerender('6744c8f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VueQuillEditor/div/textareaModule.vue"
export default component.exports